export default "__VITE_ASSET__841f0e87__"